import { BaseService } from "./BaseService";

export class AnalyticService extends BaseService {
  async getAnalytics() {
    try {
      return this.http(`app/getAnalytics`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getAllAnalytics() {
    try {
      return this.http(`app/getAllAnalytics`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
  async getCrashlytics() {
    try {
      return this.http(`app/getCrashlytics`, "get", {});
    } catch (error) {
      console.log("ERR ", error);
      return {
        ok: false,
        message: error.message,
      };
    }
  }
}
